import Swal from "sweetalert2";
import axios from "axios";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { FaEye } from "react-icons/fa";
import { Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../../../../utils/api";

export const MyGoalEvents = ({ roomId, setIsViewArchivedEvent }) => {
  const [goalData, setGoalData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  console.log('goalData', goalData);
  const navigate = useNavigate();


  useEffect(() => {
    getGoalNameImpact();
  }, []);

  const getGoalNameImpact = useCallback(async () => {
    setLoading(true);
    setError(false);

    // Show loading alert
    Swal.fire({
      text: "Please wait...",
      imageUrl: "https://www.finedge.in/assets/images/download.gif",
      showConfirmButton: false,
      allowOutsideClick: false,
    });

    try {
      const response = await api.get(`advisor/getGoalNameImpact/${roomId}`);
      setGoalData(response.data.goalData || {});
      Swal.close(); // Close the Swal popup when data is loaded
    } catch (error) {
      console.error("Error fetching goal data:", error);
      setError(true);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to load data. Please try again!",
      });
    } finally {
      setLoading(false);
    }
  }, [roomId]);

  // const handleViewArchiveData = (key) => {
  //   // setIsViewArchivedEvent(key);
  //   console.log("key",key);

  // };
  const handleViewArchiveData = (key) => {
    // const url = `/dashboard/portfolio-review-detail/?clientId=${roomId}&goalEventId=${key}`;
    const url = `/portfolio-review-detail/?clientId=${roomId}&goalEventId=${key}`;
    navigate(url);
    // window.open(url, "_blank");
  };


  const renderGoals = useMemo(
    () => (goals) => {
      return Object.keys(goals).map((goal, idx) => (
        <span key={idx}>
          {goal}
          {idx < Object.keys(goals).length - 1 && ", "}
        </span>
      ));
    },
    []
  );

  if (Object.keys(goalData).length === 0) {
    return (
      <Alert
        variant="success"
        className="fw-bold d-block text-center mt-4"
      >
        No Data Found
      </Alert>
    )
  }
  return (
    <>
      {/* ✅ DESKTOP TABLE VIEW */}
      <div className=" d-none d-md-block">
        <table className=" ms-2 table table-striped table-hover">
          <thead>
            <tr>
              <th className="txt-color-revers sticky-header back-clrgreen fs-14 m-0" style={{ paddingLeft: "50px" }}>S. #</th>
              <th className="txt-color-revers sticky-header back-clrgreen fs-14 m-0">Date</th>
              <th className="txt-color-revers sticky-header back-clrgreen fs-14 m-0">Goals Impacted</th>
              <th className="txt-color-revers sticky-header back-clrgreen fs-14 m-0">View</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" className="text-center py-3">Loading...</td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="4" className="text-center py-3">
                  Failed to load data.
                  <button className="btn btn-sm btn-primary ms-2" onClick={getGoalNameImpact}>
                    Retry
                  </button>
                </td>
              </tr>
            ) : Object.keys(goalData).length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center py-3">No Data Found</td>
              </tr>
            ) : (

              Object.entries(goalData)
              .sort((a, b) => new Date(b[1].Date) - new Date(a[1].Date)) // 👈 Sort by Date DESC
                .map(([key, value], index) => (  
                  <tr key={key}>
                    <td>
                      <p className="ms-5 fw-normal m-0" style={{ fontSize: '14px' }}>
                        {index + 1}
                      </p>
                    </td>

                    <td>
                      <p className=" fw-normal m-0" style={{ fontSize: '14px' }}>
                        {value.Date}
                      </p>
                    </td>

                    <td>
                      <p className=" fw-normal m-0" style={{ fontSize: '14px' }}>
                        {renderGoals(value.Goals)}
                      </p>
                    </td>

                    <td>
                      <FaEye
                        className="cursor-pointer clrgreen"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleViewArchiveData(key)}
                      />
                    </td>

                  </tr>
                ))
            )}
          </tbody>
        </table>
      </div>

      {/* ✅ MOBILE CARD VIEW */}
      <div className="d-block d-md-none">
        {loading ? (
          <p className="text-center">Loading...</p>
        ) : error ? (
          <div className="text-center">
            <p className="text-danger">Failed to load data.</p>
            <button className="btn btn-sm btn-primary" onClick={getGoalNameImpact}>
              Retry
            </button>
          </div>
        ) : Object.keys(goalData).length === 0 ? (
          <p className="text-center">No Data Found</p>
        ) : (
          Object.entries(goalData).map(([key, value], index) => (
            <div
              key={key}
              className="border border-1 rounded-3 mb-2 p-3 bg-white shadow-sm"
            >
              <div className="d-flex justify-content-between mb-2">
                <p className="fs-14 fw-bold">#{index + 1}</p>
                <FaEye
                  className="text-success cursor-pointer"
                  onClick={() => handleViewArchiveData(key)}
                  style={{ cursor: "pointer" }}
                />
              </div>

              <div className="d-flex justify-content-between mb-2">
                <p className="fs-14 fw-semibold">Date:</p>
                <p className="fs-14">{value.Date}</p>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <p className="fs-14 fw-semibold">Goals Impacted:</p>
                <p className="fs-14 text-end">{renderGoals(value.Goals)}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );

};
